import { TweenMax, Expo } from 'gsap'
import SiteStructure from '../../tools/site-structure'
import DragCursor from '../../tools/drag-cursor'
import EventBus from './../../../event-bus'
import StageUtils from '../../tools/stage-utils'

const DRAG_SENSITIVITY = 250
const CAROUSEL_TAP_EXIT_SENSITIVITY = 125
const DRAG_UP_TIME_SENSITIVITY = 170
const DRAG_UP_TIME_DISTANCE = 55

class PageCarousel {
  init (vm, contentManager, index) {
    this.vm = vm
    this.contentManager = contentManager
    this.eventPrefix = this.contentManager.eventPrefix
    vm.$el.addEventListener('touchstart', this.press)
    vm.$el.addEventListener('touchmove', this.touchmove)
    vm.$el.addEventListener('touchend', this.releasePress)
    vm.$el.addEventListener('touchendoutside', this.releasePress)

    EventBus.$on('touchstart', this.press)
    EventBus.$on('touchmove', this.touchmove)
    EventBus.$on('touchend', this.releasePress)
    EventBus.$on('touchendoutside', this.releasePress)

    EventBus.$on('GUIDE.ENTER_CAROUSEL_MODE', this.enterCarouselMode)
    EventBus.$on('GUIDE.EXIT_CAROUSEL_MODE', this.exitCarouselMode)
    EventBus.$on('HIJACK_CAROUSEL_DRAG', this.hijackDrag)

    this.highlightIndex = this.selectedIndex = index
    this.contentManager.setActiveIndex(index)
    this.dragCursor = new DragCursor(this, DRAG_SENSITIVITY, 50, 20)
  }
  destroy () {
    this.vm.$el.removeEventListener('touchstart', this.press)
    this.vm.$el.removeEventListener('touchmove', this.touchmove)
    this.vm.$el.removeEventListener('touchend', this.releasePress)
    this.vm.$el.removeEventListener('touchendoutside', this.releasePress)

    EventBus.$off('touchstart', this.press)
    EventBus.$off('touchmove', this.touchmove)
    EventBus.$off('touchend', this.releasePress)
    EventBus.$off('touchendoutside', this.releasePress)

    EventBus.$off('GUIDE.ENTER_CAROUSEL_MODE', this.enterCarouselMode)
    EventBus.$off('GUIDE.EXIT_CAROUSEL_MODE', this.exitCarouselMode)
    EventBus.$off('HIJACK_CAROUSEL_DRAG', this.hijackDrag)
  }
  press = (e) => {
    if (this.vm.$store.state.guideEngine.isRunning()) return
    this.dragCursor.onDragStart(e)
    this._touchTimestamp = Date.now()
  }
  touchmove = (e) => {
    if (this.vm.$store.state.guideEngine.isRunning()) return

    if (!this.dragCursor.dragThesholdActivated) {
      this.dragCursor.onDragMove(e, this.contentManager.data.carouselMode)
    } else if (this.dragCursor.dragThesholdActivated === 'x') {
      this.dragCursor.onDragMove(e, this.contentManager.data.carouselMode)
      if (!this.contentManager.data.carouselMode) {
        this.dragCursor.offsetInit.x = this.dragCursor.offset.x * 0.4
        this.enterCarouselMode()
      }
    }

    if (this.contentManager.data.carouselMode) {
      try {
        e.preventDefault()
      } catch (e) {
        console.log(e)
      }
    }
  }
  releasePress = (e) => {
    if (this.vm.$store.state.guideEngine.isRunning()) return

    if (this.contentManager.data.carouselMode) {
      let t = Date.now() - this._touchTimestamp
      if (
        (t < CAROUSEL_TAP_EXIT_SENSITIVITY && !this.dragCursor.hasDragged) ||
        (t < DRAG_UP_TIME_SENSITIVITY && Math.abs(this.dragCursor.offset.y) > DRAG_UP_TIME_DISTANCE)
      ) {
        this.exitCarouselMode()
      }
    }
    this.dragCursor.onDragEnd(e)
  }

  hijackDrag = (e) => {
    this.dragCursor.dragOffset(e.offset, e.complete)
  }

  setOffset (offset) {
    this.contentManager.updatePageOffset(offset * 1.2)
  }
  setHighlightIndex (index) {
    this.highlightIndex = index
    this.contentManager.setActiveIndex(index)
    this.vm.$store.state.guideEngine.carousel.cancel()
  }
  setSelectedIndex (index, duration) {
    this.selectedIndex = this.highlightIndex = index
    this.contentManager.setActiveIndex(index)
    let i = this.selectedIndex
    if (i > 0) {
      i = 0
    } else if (i <= -this.contentManager.componentList.length) {
      i = 1 - this.contentManager.componentList.length
    }
    this.selectedIndex = i
    this.contentManager.setIndex(i, duration)
  }

  enterCarouselMode = () => {
    if (this.contentManager.data.carouselMode) return
    clearTimeout(this._carouselModeDelayedTimer)
    this.contentManager.data.carouselMode = true
    this.contentManager.data.carouselModeDelayed = true
    window.requestAnimationFrame(this.adjustScrollPos)
    EventBus.dispatchEvent(this.eventPrefix + '.MENU_ENTER', {
      viaDrag: this.dragCursor.hasDragged
    })
  }
  exitCarouselMode = () => {
    if (!this.contentManager.data.carouselMode) return
    let _this = this
    this.contentManager.data.carouselMode = false
    this._carouselModeDelayedTimer = setTimeout(function () {
      _this.contentManager.data.carouselModeDelayed = false
    }, 100)
    let t = SiteStructure.getSelectedTree()
    if (t) {
      SiteStructure.setSelectedItem(SiteStructure.getSelectedTree().list[-this.selectedIndex])
      EventBus.dispatchEvent(this.eventPrefix + '.MENU_EXIT')
    }
  }
  adjustScrollPos = () => {
    let _y = StageUtils.getScrollY()
    if (_y) {
      window.scrollTo(0, 0)
      this.contentManager.data['page' + -this.selectedIndex + '_y'] = -_y
      let tweenOptions = {
        ease: Expo.easeInOut
      }
      tweenOptions['page' + -this.selectedIndex + '_y'] = 0
      TweenMax.to(this.contentManager.data, 2, tweenOptions)
    }
  }
}

export default PageCarousel
